import { connect } from 'react-redux'
import * as api from '../../../actions/api'
import * as actions from '../../../actions'
import * as constants from '../../../constants'
import { PuzzleRegister } from '../components'

const checkCompleteStep = (data, nextStep) => {
  var completed = []
  if (data.type !== '') {
    completed.push(0)    
  }
  if (data.card && data.card.moves.length > 1) {
    completed.push(1)
  }
  if (data.card && data.card.moves[data.card.moves.length - 1].number > 0 && nextStep !== 1) {
    completed.push(2)
  }
  return completed
}

const initializeStepper = (step, data, dispatch) => {
  switch(step) {
    case constants.puzzleRegisterStepperType.STEP2_PUZZLE:
      dispatch(actions.renjuBoardCard.selectedOperationMode(data.bid, constants.operationModeType.EDIT))
      break
    case constants.puzzleRegisterStepperType.STEP3_ANSWER:
      dispatch(actions.renjuBoardCard.selectedEditMode(data.bid, constants.editModeType.PUZZLE))
      dispatch(actions.renjuBoardCard.selectedOperationMode(data.bid, constants.operationModeType.SET))
      break
    default:
      break
  }
}

const mapStateToProps = (state, ownProps) => {
  const { activeStep, title, type, level, datetime, checkDateTime, isOtherAnswers, comment, tag, tags, isFetching, isCompleted, result, ready, openConfirmDialog } = state.puzzleRegister
  const { width } = state.window
  const { user } = state.authentication
  const { language } = state.user
  var bid, cards, card, completed, id
  bid = state.renjuBoardCards.cards.findIndex((card) => card.type === constants.boardType.PUZZLE_REGISTER)
  cards = state.renjuBoardCards.cards.filter((card) => card.type === constants.boardType.PUZZLE_REGISTER)
  card = cards.length >= 0 ? cards[0] : undefined
  id = ownProps.match ? ownProps.match.params.id : undefined

  var data = {
    user,
    id,
    title,
    type,
    level,
    datetime,
    checkDateTime,
    isOtherAnswers,
    comment,
    tags,
    bid,
    card,
    windowWidth: width,
    language
  }
  completed = new Set(checkCompleteStep(data, activeStep))

  return ({
    id,
    activeStep,
    completed,
    isFetching,
    isCompleted,
    result,
    tag,
    ready,
    openConfirmDialog,
    ...data,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: () => {
      dispatch(api.puzzle.select(
        { id: ownProps.match.params.id, own: true },
        (response) => {
          dispatch(actions.puzzleRegister.responseSelectPuzzle(response))
        }
      ))
    },
    handleNextRegistration: () => {
      dispatch(actions.puzzleRegister.init())
    },
    horizontalLinearStepper: {
      handleStep: (data, step) => () => {
        if (
          step === constants.puzzleRegisterStepperType.STEP2_PUZZLE &&
          data.card.moves[data.card.moves.length - 1].number > 0
        ) {
          dispatch(actions.puzzleRegister.confirmDialog.open())
        }
        else {
          dispatch(actions.puzzleRegister.selectedStep(step))
          window.scrollTo(0, 0)
          initializeStepper(step, data, dispatch)
        }
      }
    },
    stepperControlButtons: {
      handleNext: (data, activeStep) => () => {
        if (
          activeStep + 1 === constants.puzzleRegisterStepperType.STEP2_PUZZLE &&
          data.card.moves[data.card.moves.length - 1].number > 0
        ) {
          dispatch(actions.puzzleRegister.confirmDialog.open())
        }
        else {
          dispatch(actions.puzzleRegister.next())
          window.scrollTo(0, 0)
          initializeStepper(activeStep + 1, data, dispatch)
        }
      },
      handleBack: (data, activeStep) => () => {
        if (
          activeStep - 1 === constants.puzzleRegisterStepperType.STEP2_PUZZLE &&
          data.card.moves[data.card.moves.length - 1].number > 0
        ) {
          dispatch(actions.puzzleRegister.confirmDialog.open())
        }
        else {
          dispatch(actions.puzzleRegister.back())
          window.scrollTo(0, 0)
          initializeStepper(activeStep - 1, data, dispatch)
        }
      },
      handleBackFirst: (data) => () => {
        dispatch(actions.puzzleRegister.backFirst())
        window.scrollTo(0, 0)
        initializeStepper(0, data, dispatch)
      },
      handleDecision: (data) => () => {
        dispatch(actions.puzzleRegister.selectedStep(constants.puzzleRegisterStepperType.STEP4_CONFIRM))
        window.scrollTo(0, 0)
        initializeStepper(constants.puzzleRegisterStepperType.STEP4_CONFIRM, data, dispatch)
      },
      handlePost: (data) => () => {
        if (ownProps.match && ownProps.match.params.id) {
          dispatch(api.puzzle.update(data))
        }
        else {
          dispatch(api.puzzle.add(data))
        }
      }
    },
    stepper1: {
      handleChangedText: (name) => (event) => {
        dispatch(actions.puzzleRegister.changedText(name, event.target.value))
      },
      handleChangedCheckbox: (name) => (event) => {
        dispatch(actions.puzzleRegister.changedCheckbox(name, event.target.checked))
      },
      handleDeleteTag: (index) => () => {
        dispatch(actions.puzzleRegister.removeTag(index))
      },
      handleAddTag: () => {
        dispatch(actions.puzzleRegister.addTag())
      },
      handleKeyDown: (event) => {
        if (event.keyCode === 13) {
          dispatch(actions.puzzleRegister.addTag())
        }
      }
    },
    confirmDialogProps: {
      handleOpen: () => {
        dispatch(actions.puzzleRegister.confirmDialog.open())
      },
      handleClose: () => {
        dispatch(actions.puzzleRegister.confirmDialog.close())
      },
      handleOK: (data) => () => {
        dispatch(actions.puzzleRegister.selectedStep(constants.puzzleRegisterStepperType.STEP2_PUZZLE))
        window.scrollTo(0, 0)
        initializeStepper(constants.puzzleRegisterStepperType.STEP2_PUZZLE, data, dispatch)
        dispatch(actions.puzzleRegister.confirmDialog.close())
      }
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PuzzleRegister)


// WEBPACK FOOTER //
// ./src/Pages/Puzzle/containers/PuzzleRegister.js